import React from "react";
import {useTranslation} from "react-i18next";
import {setStoredRowColoring} from "./storage";

import MDTypography from "../../materialDashboard/components/MDTypography";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "../../materialDashboard/components/MDInput";
import MDBox from "../../materialDashboard/components/MDBox";

const RowColoringSelector = ({rowColoring, setRowColoring, dataTableId, coloringOptions = []}) => {
    const {t} = useTranslation(["components"]);

    const options = coloringOptions.map(opt => {
        let label = opt.label;
        if (!label) {
            if (opt.value === "none") label = t("dataTable.coloring.none");
            else if (opt.value === "alternate") label = t("dataTable.coloring.alternate");
            else label = t(`dataTable.coloring.${opt.value}`, {defaultValue: opt.value});
        } else {
            label = t(label, {defaultValue: label});
        }
        return {
            value: opt.value,
            label: label
        };
    });

    const currentOption = options.find(opt => opt.value === rowColoring) || options[0];

    const handleRowColoringChange = (newValue) => {
        if (!newValue) return;
        setRowColoring(newValue.value);
        if (dataTableId) {
            setStoredRowColoring(dataTableId, newValue.value);
        }
    }

    return (
        <MDBox display={{sm: "flex", xs: "none"}} alignItems="center" ml="auto" mr={2}>
            <MDTypography variant="caption" color="secondary">
                {t("dataTable.coloring.label")} &nbsp;&nbsp;
            </MDTypography>
            <Autocomplete
                disableClearable
                value={currentOption}
                options={options}
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) => {
                    handleRowColoringChange(newValue);
                }}
                size="small"
                sx={{width: "12rem"}}
                renderInput={(params) => <MDInput {...params} />}
            />
        </MDBox>
    );
}

export default RowColoringSelector;
